<template>
  <div class="detail-container">
    <div class="logo-container">
      <img
        src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/logo.png"
        alt=""
        class="logo"
      />
    </div>
    <div class="img-container">
      <div class="go-back-bt-aaa" @click="goBack">返回</div>
      <img :src="detailImgSrc" alt="" class="detail-img" />
    </div>
    <div class="tip-line-1" v-if="explain[0]">
      <span class="text" v-html="explain[0]"></span>
    </div>
    <div class="tip-line-2" v-if="explain[1]">
      <span class="text" v-html="explain[1]"></span>
    </div>
    <div class="enter-bt" @click="next">点击进入</div>
  </div>
</template>

<script>
import { areaInfoList } from "../data";
export default {
  data() {
    return {
      detailImgSrc: "",
      explain: [],
    };
  },
  mounted() {
    const where = this.$route.params.where;
    const info = areaInfoList[where];
    this.detailImgSrc = info.detailImg;
    this.explain = info.explain;
    info.wxMsg && this.$wx(info.wxTitle, info.wxMsg);
  },
  methods: {
    next() {
      this.$router.replace(`/detail-2/${this.$route.params.where}`);
      // this.$router.replace(`/detail-2/suqian`);
    },

    goBack() {
      this.$router.replace(`/thirteen-city?city=${this.$route.params.where}`);
    },
  },
};
</script>

<style scope>
.detail-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.logo-container {
  display: flex;
  align-items: flex-end;
}

.logo {
  margin-right: 4vw;
  margin-left: auto;
  display: block;
  width: 20vw;
}

.img-container {
  position: relative;
  height: 112.65vw;
}

@media screen and (min-width: 640px) {
  .logo {
    margin-right: 40px;
    margin-left: auto;
    display: block;
    width: 128px;
  }

  .detail-container .img-container {
    pointer-events: none;
  }

  .go-back-bt-aaa {
    pointer-events: all;
    cursor: pointer;
  }

  .enter-bt {
    cursor: pointer;
  }
}

.go-back-bt-aaa {
  width: 61px;
  height: 22px;
  background: #ffde98;
  box-shadow: 0px 3px 17px 0px rgba(146, 5, 0, 0.46);
  border-radius: 11px;

  font-size: 15px;
  color: #990100;
  line-height: 22px;
  text-align: center;
  margin-left: 7vw;
  position: absolute;
  left: 0;
  top: -22px;
}

.enter-bt {
  width: 120px;
  height: 32px;
  background: #ffde98;
  box-shadow: 0px 3px 17px 0px rgba(146, 5, 0, 0.46);
  border-radius: 16px;

  font-size: 15px;
  color: #990100;
  line-height: 32px;
  text-align: center;
  margin: 50px auto;
}

.detail-img {
  width: 100%;
  min-height: 30vh;
}

@media screen and (max-height: 650px) {
  .detail-img {
    width: 80%;
    margin: 0 auto;
    display: block;
  }

  .enter-bt {
    margin: 40px auto 0;
  }
}

@media screen and (min-width: 640px) {
  .detail-img {
    width: 500px;
    margin: 0 auto;
    display: block;
  }
}
</style>

<style>
.tip-line-1,
.tip-line-2 {
  text-align: center;
  letter-spacing: 1px;
}

.tip-line-1 {
  margin-bottom: 8px;
  margin-top: -10vw;
}

.tip-line-1 .text {
  font-size: 18px;
  line-height: 32px;
  color: #ffde98;
  font-style: italic;
  border-bottom: 1px solid #ffde98;
}

.tip-line-2 .text {
  font-size: 20px;
  line-height: 32px;
  color: #ffde98;
  font-style: italic;
  border-bottom: 1px solid #ffde98;
}

.tip-line-1 .strong {
  font-size: 22px;
}

.tip-line-2 .strong {
  font-size: 24px;
}
</style>